export default __webpack_public_path__ + "media/DropFile.8b32f3dc.svg";